/* eslint-disable prettier/prettier */

import { SELECTORS } from '$utils/constants';
import { setupFilterComponents } from '$utils/helpers/setupFilterComponents';

window.Webflow ||= [];
window.Webflow.push(() => {
  // Influencer Elements

  setupFilterComponents(true);
});
